import React, { useState } from 'react';
import './HelpDesk.css';
import { FaQuestionCircle } from 'react-icons/fa';
import FAQs from '../GettingStartedFAQs/GettingStartedFAQs';
import { Helmet } from "react-helmet-async";
const HelpDesk = () => {
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const helpTopics = [
    { key: 'getting-started', label: 'Getting Started' },
    { key: 'how-to-play', label: 'How to Play' },
    // { key: 'my-balance', label: 'My Balance' },
    { key: 'network-on-nifty10', label: 'Network on Nifty10' },
    // { key: 'offers-and-rewards', label: 'Offers & Rewards' },
    { key: 'profile-verification', label: 'Profile & Verification' }
  ];
const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === '') {
      setSearchResults([]);
    } else {
      const results = [];

      Object.entries(FAQs).forEach(([topicKey, topicContent]) => {
        topicContent.categories.forEach(category => {
          category.questions.forEach(question => {
            if (
              question.question.toLowerCase().includes(term) ||
              question.answer.toLowerCase().includes(term)
            ) {
              results.push({
                topic: topicKey,
                category: category.category,
                question: question.question,
                answer: question.answer,
              });
            }
          });
        });
      });

      setSearchResults(results);
    }
  };

  return (
    <>
    <Helmet>
        <title>Helpdesk | Nifty10</title>
        <meta
          name="description"
          content="Need help with Nifty10? Visit our helpdesk for support, FAQs, and quick resolutions to your queries."
        />
      </Helmet>
    <div className="help-desk-container">
      <header className="help-header">
        <h1 className="help-title">Help Desk</h1>
        <p className="help-subtitle">How can we help you today?</p>
      </header>

      {!selectedTopic ? (
        <section className="help-topics-section">
          <h2 className="help-topics-heading">
            <FaQuestionCircle className="help-icon" /> Help Topics
          </h2>
          <div className="card-container">
            {helpTopics.map((topic, index) => (
              <div
                className="help-topic-card"
                key={index}
                onClick={() => setSelectedTopic(topic.key)}
              >
                <p className="help-topic-title">{topic.label}</p>
              </div>
            ))}
          </div>
        </section>
      ) : (
        <div>
          <button className="back-button" onClick={() => setSelectedTopic(null)}>← Back to Topics</button>
          <FAQs topicKey={selectedTopic} />
        </div>
      )}
    </div></>
  );
};

export default HelpDesk;
